module.exports = __webpack_public_path__ + "assets/17aee2a3b4dbb84d711eef79005edf11.png";